import imageStore from "components/ShoppableImage/imageStore"

import "components/ShoppableImage/ShoppableImage.css"
import { observer } from "mobx-react"
import queryString from "qs"
import React from "react"
import { withRouter, Link } from "react-router-dom"
import { Container, Segment, Card, Divider, Image, Icon, Header, Button } from "semantic-ui-react"
import { Loading } from "components/Spinner/Spinner"
import shop from "shop/shop"

import ImageCard from "./ImageCard"
import CategoryCard from "./CategoryCard"

import cmsStore from "stores/cmsStore"

@withRouter
@observer
export default class ShoppableCategoryPage extends React.Component {

  componentDidMount() {
    imageStore.getIndex()
  }

  render() {
    const query = queryString.parse( this.props.location.search, { ignoreQueryPrefix: true } )
    const { categorySlug } = this.props.match.params
    const { useEditor } = cmsStore
    const { categoryBySlug, categories, byCategory } = imageStore
    const category = categoryBySlug.get( categorySlug )
    const images = byCategory.get( categorySlug ) || []
    if ( !category ) return <Loading/>
    const hasContent = images.length > 0
    return <div className="ShoppableCategoryPage pv4 pb6">
      <Container>
        <h2><Button basic circular as={Link} to={`/bildwelt`} icon={"chevron left"}/> {category.name}</h2>

        {!hasContent && <div className="pv4"><Segment>Noch keine Bildwelten vorhanden. Hier gibt es in Kürze Inhalte.</Segment></div>}

        <Card.Group doubling itemsPerRow={4}>
          {images.map( image => <ImageCard key={image.id} image={image} categorySlug={categorySlug}/> )}

          {useEditor && <Card
            className={"relative"}
            as={"a"}
            href={`${shop.config.BASE}/wp/wp-admin/post-new.php?post_type=bildwelt`} target={"_blank"}>
            <div className="ph2 pv4">
              <Icon name={"plus"}/> Neue Bildwelt anlegen
            </div>
          </Card>}
        </Card.Group>

        <div className="pt4 pt5-ns">
          <Header size={"small"}><div className="fw2 black-60 ttu">Alle Bildwelt-Kategorien</div></Header>
          <Card.Group itemsPerRow={5}>
            {categories.map( category => <CategoryCard key={category.term_id} category={category}/> )}
            {useEditor &&
            <Card
              className={"relative"}
              as={"a"}
              href={`${shop.config.BASE}/wp/wp-admin/edit-tags.php?taxonomy=bildwelt_category&post_type=bildwelt`} target={"_blank"}>
              <div className="ph2 pv4">
                <Icon name={"plus"}/> Neue Kategorie anlegen
              </div>
            </Card>}
          </Card.Group>
        </div>

      </Container>
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/ShoppableImage/ShoppableCategoryPage.js